import Moment from 'moment';
import { jwtDecode } from 'jwt-decode';
import Api from '@/mixins/api';

const Helpers = {
	contactMethodOptions: [
		'Email',
		'Mobile'
	],
	expectedPurchaseOptions: [
		'ASAP', 'Within The Month', 'Undecided'
	],
	livingStatus: [
		{value: "2", label: 'Own Home (Mortgage)'},
		{value: "1", label: 'Own Home (No Mortgage)'},
		{value: "3", label: 'Renting'},
		{value: "4", label: 'Boarding'},
		{value: "5", label: 'Living With Parents'}
	],
	blankPreApproval: {
		response: {
			customer: {
				preApproval: {
					preApprovalId: "",
					preApprovalStatus: ""
				}
			}
		}
	},
	getFinanceTypeFromCashFinanceTab(v: number): number {
		switch (v){
			case 0: {
				return 0;
			}
			case 1: {
				return 1;
			}
			case 2: {
				return 4;
			}
			default: {
				return 0;
			}
		}
	},
	resetAllCookies(){
		console.log('resetting cookies');
		const cd = ';path=/;expires=Thu, 01 Jan 1970 00:00:00 GMT';
		const pegacaseCookie = Helpers.getCookie('tprcaseid') || '';
		const tokenCookie = Helpers.getCookie('token') || '';
		const ogCookie = Helpers.getCookie('omniguid') || '';
		const tprguidCookie = Helpers.getCookie('tprguid') || '';
		if (tokenCookie){
			document.cookie = 'token=' + tokenCookie + cd;
		}
		if (ogCookie){
			document.cookie = 'omniguid=' + ogCookie + cd;
		}
		if (tprguidCookie){
			document.cookie = 'tprguid=' + tprguidCookie + cd;
		}
		if (pegacaseCookie){
			document.cookie = 'tprcaseid=' + pegacaseCookie + cd;
		}
	},
	setFinanceStoreAndCookies(vm: any, financeData: any, appData: any){
		const d = new Date();
		d.setDate(d.getDate() + 7 * 2);
		const ft = financeData.financeType || 1;
		const deposit = financeData.financeDeposit || 0;
		const term = vm.$store.state.app.loanTerm || 0;
		const kmsOrBalloon = ft == 1 ? vm.$store.state.app.kmsPerYear || 0 : vm.$store.state.app.balloonPercentage || 0;

		vm.$store.commit('setFinance', financeData);
		vm.$store.commit('setAppFinanceOptions', {
			financeDeposit: financeData.financeDeposit,
			termsInYears: appData.loanTerm,
			kms: appData.kmsPerYear,
			balloonPercentage: appData.balloonPercentage,
			financeType: financeData.financeType
		});

		Helpers.setFinanceOptionCookie(d.toString(), deposit, term, kmsOrBalloon, ft);
	},
	setFinanceOptionCookie(validityDate: string, deposit: number | string, term: number | string, kms: number | string, ft: number) {
		let dateexp = new Date(validityDate);
		const expires = "expires=" + dateexp.toString();
		const cookieData = ";" + expires + ';path=/';
		document.cookie = "financeoptions=" + deposit + '_' + term + '_' + kms + '_' + (ft || 1) + cookieData;
		console.log('set financeoptions cookies with ' + deposit + '_' + term + '_' + kms + '_' + (ft || 1) + cookieData);
	},
	getMaxBalloonPercentage(termsInYears: number): number {
		switch (termsInYears) {
			case 1:
				return 60;
			case 2:
				return 50;
			case 3:
				return 40;
			case 4:
				return 30;
			case 5:
				return 25;
			default:
				return 0;
		}
	},
	setTokenCookie(token: any, tprExpiry: any){
		console.log('setTokenCookie bf',token);
		if (!token) return;
		console.log('setTokenCookie af1');
		const obj = (jwtDecode as any)(token);
		if (obj.auth_level < 100) return;
		console.log('setTokenCookie af2');

		const dateexp = new Date(parseInt(`${obj.exp}000`));
		const expires = "expires="+ dateexp.toString();
		const cookieData = ";" + expires + ';path=/';
		document.cookie = "token=" + token + cookieData;

		console.log('setTokenCookie', "token=" + token + cookieData);

		console.log('bf if setOmniGuidCookie', tprExpiry);
		if (tprExpiry){
			Helpers.setOmniGuidCookie(obj.omni_guid, tprExpiry);
		}
	},
	setOmniGuidCookie(guid: any, tprExpiry: any){
		let dateexp = new Date(tprExpiry);
		let expires = "expires="+ dateexp.toString();
		let cookieData = ";" + expires + ';path=/';
		document.cookie = "omniguid=" + guid + cookieData;
		document.cookie = "omniguidexpiry=" + tprExpiry + cookieData;
		console.log('setOmniGuidCookie', guid, tprExpiry);
	},
	setTprGuidCookie(pegaCase: any, validityDate: any, guid: any){
		let caseId = pegaCase.replace('TPR-', '');
		let dateexp = new Date(validityDate);
		let expires = "expires="+ dateexp.toString();
		let cookieData = ";" + expires + ';path=/';
		document.cookie = "tprguid=" + guid + cookieData;
		document.cookie = "tprcaseid=" + caseId + cookieData;
		console.log('set cookies with ' + guid + ', ' + cookieData);
	},
	setObject: (obj: any, obj2: any) => {
		for (const key in obj2) {
			if (obj2.hasOwnProperty(key)) {
				obj[key] = obj2[key]
			}
		}
	},
	formatPrice(p: number): string {
		const whole = Math.floor(p);
		const remainder = p - whole;
		const formatter = new Intl.NumberFormat('en-AU', {
			style: 'currency',
			currency: 'AUD',
			minimumFractionDigits: remainder ? 2 : 0
		});
		return formatter.format(p);
	},
	getFinanceHeadingListItems(financeHeading: string): Array<string> {
		financeHeading = financeHeading.replace(/\./g, ".\n");
		financeHeading = financeHeading.replace(/ and a/g, ".\n");
		const financeHeadingArr = financeHeading.split(/\n/g);
		const items = [];
		for (let i = 0; i != financeHeadingArr.length; ++i){
			let newTxt = financeHeadingArr[i].trim();
			newTxt = newTxt.charAt(0).toUpperCase() + newTxt.slice(1);
			if (newTxt.length){
				items.push(newTxt);
			}
		}
		return items;
	},
	getEnquirySources(): any {
		return {
			'Normal': 1,
			'KIOSK_SHOWROOM': 2,
			'KIOSK_SERVICE': 3,
			'QR_SHOWROOM': 4,
			'QR_SERVICE': 5,
			'SDL_QR': 6
		};
	},
	getLongestCommonStartingSubstring(arr1: Array<any>): string {
		const arr= arr1.concat().sort();
		const a1= arr[0];
		const a2= arr[arr.length-1];
		const L= a1.length;
		let i= 0;
		while(i< L && a1.charAt(i)=== a2.charAt(i)) i++;
		return a1.substring(0, i);
	},
	formattedDateMinusOneDay(d: any): string {
		const m = Moment(d).subtract(1, 'days');
		return m.format('Do MMMM YYYY');
	},
	formattedDate(d: any): string {
		const m = Moment(d)
		return m.format('Do MMMM YYYY');
	},
	shortFormattedDate(d: any): string {
		const m = Moment(d)
		return m.format('D MMM YYYY');
	},
	extractDisclaimerKeys(disclaimer: string): Array<any>{
		const keys = [];
		const arr = disclaimer.split('[');
		for (let i = 0; i != arr.length; ++i){
			if (arr[i].length){
				const arr2 = arr[i].split(']');
				if (arr2.length){
					keys.push('['+arr2[0]+']');
				}
			}
		}
		return keys;
	},
	getCookie(name: string): string {
		const match = document.cookie.match(new RegExp(name + '=([^;]+)'));
		if (match) return match[1];
		return '';
	},
	getNumberFromString(s: string): number {
		return parseInt(s.replace(/[^\d]/g, ''));
	},
	getFormattedPrice(p: number): string {
		const whole = Math.floor(p);
		const remainder = p - whole;
		const formatter = new Intl.NumberFormat('en-AU', {
			style: 'currency',
			currency: 'AUD',
			minimumFractionDigits: remainder ? 2 : 0
		});
		return formatter.format(p);
	},
	getColour(code: string): string {
		const colourMap: any = {
			'040': '#fff',
			'219': '#000',
			'218': '#000',
			'LB20': '#000',
			'3U5': 'red',
			'EA20': '#000'
		};
		return code ? colourMap[code] || '' : '';
	},
	clog(v: any): void {
		if (-1 != location.hostname.indexOf('localhost') || -1 != location.hostname.indexOf('test.dealer')){
			console.log(v);
		}
	}
}
export default Helpers;
